/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// CART DOT — show only when cart has items
// Venue renders two cart-link elements (desktop + mobile trigger).
// Each has its own .cart-count-bubble and <items-count> child.
// querySelector only finds the first one, so we loop all cart-links instead.
// CSS hides the bubble by default (display: none, no !important).
// This script shows it (display: block) when count > 0 and clears the
// inline style when 0, letting CSS hide it again.
(function () {
  function init() {
    var cartLinks = document.querySelectorAll('cart-link');

    if (!cartLinks.length) {
      // Fallback: no cart-link custom elements found
      var bubble = document.querySelector('.cart-count-bubble');
      var counter = document.querySelector('items-count');
      if (bubble) setup(bubble, counter);
      return;
    }

    cartLinks.forEach(function (cartLink) {
      var bubble = cartLink.querySelector('.cart-count-bubble');
      var counter = cartLink.querySelector('items-count');
      if (bubble) setup(bubble, counter);
    });
  }

  function setup(bubble, counter) {
    function sync() {
      var src = counter || bubble;
      var count = parseInt(src.textContent || '0', 10);
      bubble.style.display = count > 0 ? 'block' : '';
    }
    sync();
    new MutationObserver(sync).observe(counter || bubble, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
